module.exports = __webpack_public_path__ + "img/de-logo_no_line.27212bae.png";